import React, { useEffect, useState } from "react";
// import { Link } from 'react-router-dom'
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./AskQ.css";
import api from "../../utils/api";
import { Box, Typography } from "@mui/material";
import Swal from "sweetalert2";
const swalWithBootstrapButtons = Swal.mixin({
  customclassName: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});
const categories = [
  "hostels",
  "internships",
  "scholarships",
  "projects",
  "fyps",
  "development",
  "technology",
  "design",
  "courses",
  "digitalMarketing",
];

export const AskQ = (props) => {
  const params = useParams();
  let navigate = useNavigate();
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const [question, setQuestion] = useState("");
  const [image, setImage] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState([]);
  const [tagsText, setTagsText] = useState("");
  const [errors, setErrors] = useState({});
  const [qForEdit, setQForEdit] = useState({});
  const [categoriesInterested, setCategoriesInterested] = useState([]);
  const [suggestedTags, setSuggestedTags] = useState([]);

  useEffect(() => {
    console.log("current user>>>", currentUser);
  }, [currentUser]);
  useEffect(() => {
    if (params?.questionId) {
      api
        .get(`/questions/by-id/${params.questionId}`)
        .then((res) => {
          if (res.data) {
            console.log("q for edit", res.data);
            setQuestion(res.data?.question);
            setDescription(res.data?.description);
            setImage(res.data?.image);
            setTags(res.data?.tags);
          }
        })
        .catch((err) => console.log);
    }
  }, []);
  useEffect(() => {
    console.log("tags text");
    if (tagsText) {
      const Array = tagsText?.split(",");
      let Array2 = Array.filter((arr) => arr !== "");
      setTags(Array2);
    }
  }, [tagsText]);
  const uploadPhoto = async (e) => {
    console.log("e.target", e.target);
    console.log("running upload file ");
    let files = e.target.files;
    if (files?.length > 0) {
      const signResponse = await api.get("/signuploadform");
      const signData = await signResponse.data;
      console.log("sign data", signData);
      // return;
      /****** */
      const data = new FormData();

      data.append("file", files[0]);
      // data.append("upload_preset", "klv1irxe");
      data.append("api_key", signData.apikey);
      data.append("timestamp", signData.timestamp);
      data.append("signature", signData.signature);
      data.append("eager", "c_fill,h_400,w_600");
      // data.append("eager", "c_pad,h_100,w_500|c_crop,h_100,w_500");
      try {
        const res = await fetch(
          "https://api.cloudinary.com/v1_1/" +
            signData.cloudname +
            "/auto/upload",

          {
            method: "POST",
            body: data,
          }
        );
        const file = await res.json();
        console.log("response from cloudinary>>>", file);
        setImage(file?.eager[0]?.secure_url);
        let e2 = { target: { name: "image", value: file.secure_url } };
      } catch (err) {
        console.log("error while uploading images", err);
      }
    }

    // console.log("file profie image>>> ", file);
  };
  useEffect(() => {
    console.log("image", image);
  }, [image]);
  const onChangeCategoriesInterested = (value) => {
    let array = categoriesInterested;
    let res = array.includes(value);
    // console.log("res", res);
    if (res) {
      array = array?.filter((a) => a !== value);
      setCategoriesInterested(array);
    } else {
      //   array.push(value);

      setCategoriesInterested([...array, value]);
    }
  };
  useEffect(() => {
    console.log("categories Interested", categoriesInterested);
    let catgs = [];
    console.log(
      'categoriesInterested.includes("hostels")',
      categoriesInterested.includes("hostels")
    );
    if (categoriesInterested.includes("hostels")) {
      catgs = [
        ...catgs,
        "furnished",
        "single rooms",
        "male hostel",
        "female",
        "Non-furnished",
      ];
      console.log("catgs", catgs);
    }

    if (categoriesInterested.includes("internships")) {
      catgs = [...catgs, "Paid", "Unpaid", "remote", "hybrid", "onsite"];
    }
    if (categoriesInterested.includes("scholarships")) {
      catgs = [
        ...catgs,
        "Government",
        "Need base",
        " merit base",
        "national and international",
      ];
    }
    if (categoriesInterested.includes("projects")) {
      catgs = [
        ...catgs,
        "paid projects",
        " unpaid projects",
        "research projects",
        "programming",
        "writing projects",
      ];
    }
    if (categoriesInterested.includes("fyps")) {
      catgs = [...catgs, "new", "already created", "research", "development"];
    }
    if (categoriesInterested.includes("development")) {
      catgs = [
        ...catgs,
        "mobile dev",
        "web dev",
        "data science",
        " machine learning",
        "AI",
      ];
    }
    if (categoriesInterested.includes("technology")) {
      catgs = [
        ...catgs,
        "future trends",
        "block chain",
        "NFTs",
        "AI",
        "web 3.0",
      ];
    }
    if (categoriesInterested.includes("design")) {
      catgs = [
        ...catgs,
        "UI/UX",
        "logo design",
        "Poster design",
        " Game design",
        "NFT design",
      ];
    }
    if (categoriesInterested.includes("courses")) {
      catgs = [...catgs, "pre-raq", "electives", "compulsory", "credit hours"];
    }
    if (categoriesInterested.includes("digitalMarketing")) {
      catgs = [
        ...catgs,
        "SEO",
        "public relation",
        " guest posting",
        "Display advertising",
        "Affiliate marketing",
      ];
    }

    setSuggestedTags(catgs);
    console.log("suggested tags", catgs);
  }, [categoriesInterested]);
  const handleFormSubmit = () => {
    console.log("question>", question);
    console.log("description>", description);
    console.log("image>", image);
    console.log("tags>", tagsText);
    let errs = {};
    if (!question) {
      errs.question = "question is required";
    }
    if (!description) {
      errs.description = "description is required";
    }
    //else if (description.length < 100) {
    //   errs.description = "atleast 100 chrachters required";
    // }
    // if (!image) {
    //   errs.image = "image is required";
    // }

    // if (!tagsText && !params?.questionId) {
    //   errs.tags = "tags are required";
    // }
    // if (tags.length < 2 || tags.length > 5) {
    //   errs.tags = "atleast 2 tags are required , atmost 5";
    // }
    if (tags?.length < 1) {
      errs.tags = "tags are required";
    }
    if (categoriesInterested?.length < 1) {
      errs.categoriesInterested = "select atleast one category";
    }
    setErrors(errs);
    if (Object.keys(errs).length === 0 && errs.constructor === Object) {
      console.log("submitting form");
      const body = {
        userId: currentUser.id,
        user: currentUser,
        question,
        description,
        categoriesInterested,
        image,
        tags,
      };
      if (params?.questionId) {
        //for updating question
        api
          .put(`/questions/update/${params?.questionId}`, body)
          .then((res) => {
            if (res.data) {
              Swal.fire("Question Updated Successfully!", "", "success");
              navigate("/home");
            }
          })
          .catch((err) => {
            swalWithBootstrapButtons.fire(
              "Question Updation Unsuccessful!",
              "Something goes wrong",
              "error"
            );
            // alert("question post failed");
          });
      } else {
        //for uploading new question
        api
          .post("/questions", body)
          .then((res) => {
            if (res.data) {
              Swal.fire("Question Submitted Successfully!", "", "success");
              let notifBody = {
                userId: currentUser?.id,
                text: `${currentUser?.name} asked a question`,
              };
              api
                .post("/notifications", notifBody)
                .then((re) => console.log("notif", re.data));
              navigate("/my-questions");
            }
          })
          .catch((err) => {
            // alert("question post failed");
            swalWithBootstrapButtons.fire(
              "Question Submission Unsuccessful!",
              "Something goes wrong",
              "error"
            );
          });
      }
    }
  };
  return (
    <Box sx={{ marginLeft: "10%" }}>
      {/* <Header />
      <Menunav /> */}
      <Box className="row">
        {/* <Box  className="col-md-2 col-0">
          <Sidebar />
        </Box > */}
        <Box className="col-md-10 col-12">
          <Box className="container">
            <Typography
              variant="h5"
              className="my-3"
              sx={{ marginLeft: "-15px" }}
            >
              {" "}
              {params?.questionId ? "Edit your question" : "Ask a Question"}
            </Typography>
            {/* <h6>Cancel</h6> */}
            <Box className="form" onSubmit={handleFormSubmit}>
              <Box className="row">
                <textarea
                  // className="p_of_askquestion p-2 border border-dark rounded my-2"
                  placeholder=" Write Question Here!"
                  id="question"
                  name="question"
                  required
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  className="input__field__asc"
                />
                {errors.question && (
                  <h6 className="signup__error__message">{errors.question}</h6>
                )}
                <textarea
                  // className="textarea_url_of_askquestion  border border-dark rounded my-2 p-2"
                  placeholder="Description"
                  id="url"
                  name="url"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="input__field__asc"
                />
                {errors.description && (
                  <h6 className="signup__error__message">
                    {errors.description}
                  </h6>
                )}
                <Typography
                  className="col-12 mt-4 "
                  variant="h6"
                  sx={{ textAlign: "left", marginBottom: "30px" }}
                >
                  Select Catgories
                </Typography>
                {errors?.categoriesInterested && (
                  <p className="error__para">{errors?.categoriesInterested}</p>
                )}
                <Box
                  sx={{
                    marginBottom: "50px",
                    display: "grid",
                    gridTemplateColumns: "40% 40%",
                  }}
                >
                  {categories?.map((c) => (
                    <Box
                      className="col-12 "
                      sx={{
                        display: "flex",
                        justifyContent: "left",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        className=""
                        id={c}
                        name={c}
                        required
                        onChange={(e) => onChangeCategoriesInterested(c)}
                        height="300px"
                        disabled={
                          categoriesInterested?.includes(c)
                            ? false
                            : categoriesInterested?.length > 1 && true
                        }
                      />
                      <Typography sx={{ textTransform: "capitalize" }}>
                        {c}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <input
                  type="file"
                  id="file"
                  name="file"
                  // className="border border-dark rounded my-2 p-2"
                  onChange={(e) => uploadPhoto(e)}
                  className="input__field__asc"
                />
                {errors.image && (
                  <h6 className="signup__error__message">{errors.image}</h6>
                )}
                {image && (
                  <Box className="image__container">
                    <img src={image} />
                  </Box>
                )}
                <textarea
                  // className="textarea_tags_of_askquestion  border border-dark rounded my-2 p-2"
                  placeholder="Tags (separate by commas)"
                  id="tags"
                  name="tags"
                  required
                  onChange={(e) => setTagsText(e.target.value)}
                  className="input__field__asc"
                />
                {errors.tags && (
                  <h6 className="signup__error__message">{errors.tags}</h6>
                )}
                <p>Suggested Tags : </p>
                {tags && (
                  <Box className="tags__container">
                    {suggestedTags
                      ?.filter((s) => !tags?.includes(s))
                      .map((tag) => (
                        <span
                          style={{
                            background: "white",
                            border: "1px solid gray",
                            borderRadius: "2px",
                            cursor: "pointer",
                          }}
                          onClick={() => setTags([...tags, tag])}
                        >
                          {tag}{" "}
                        </span>
                      ))}
                  </Box>
                )}

                <p style={{ marginTop: "20px" }}>Tags : </p>
                {tags && (
                  <Box className="tags__container">
                    {tags.map((tag) => (
                      <span
                        style={{
                          background: "#043e7d",
                          border: "1px solid lightgray",
                          borderRadius: "2px",
                          cursor: "pointer",
                          color: "white",
                        }}
                      >
                        {tag}{" "}
                      </span>
                    ))}
                  </Box>
                )}
                <button
                  className=" asc__submit__form__button cancel__form__btn"
                  onClick={() => navigate("/questions")}
                >
                  Cancel
                </button>
                <button
                  className=" asc__submit__form__button"
                  onClick={() => handleFormSubmit()}
                >
                  {params?.questionId ? "Update Question" : "Post Question"}
                </button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
